// extracted by mini-css-extract-plugin
export var jumplinkscontainer = "ParagraphJumpLinks-module--jumplinkscontainer--0794c";
export var jumpmenu = "ParagraphJumpLinks-module--jumpmenu--e244b";
export var jumpmenuform = "ParagraphJumpLinks-module--jumpmenuform--d0611";
export var links = "ParagraphJumpLinks-module--links--54983";
export var linktag = "ParagraphJumpLinks-module--linktag--4c0e0";
export var title = "ParagraphJumpLinks-module--title--a7a5c";